<template>
  <div>
    <b-breadcrumb :items="items" :key="renderBreadCrumb"> </b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row v-if="loaded" class="mx-0 mb-3">
      <b-col>
        <b-card no-body class>
          <b-tabs card content-class="mt-3" :key="renderFields">
            <b-tab title="Profil" active>
              <b-row>
                <b-col sm="12" lg="6">
                  <b-card
                    class="mb-2 shadow bg-light"
                    header-text-variant="light"
                  >
                    <b-alert
                      v-if="creditor.requiredAction.value == 'send_login'"
                      variant="warning"
                      show
                    >
                      <h6>Attention</h6>
                      <p>
                        Les codes d'autentification de ce client ont été
                        changés. Vous pouvez envoyer les codes en cliquant sur
                        ce bouton
                      </p>
                      <b-button class="mt-2" @click="send_login()" size="sm"
                        >Envoyer les codes</b-button
                      >
                    </b-alert>
                    <b-row>
                      <b-col lg="12">
                        <mh-input
                          field="nom_soc"
                          :autocomplete="{ field: 'creancier.nom_soc' }"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="2"
                          contentColsLg="10"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="ID"
                          readonly
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          label="Status"
                          field="age"
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          label="Date de création"
                          field="date_creation"
                          readonly
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          label="Relancer le créancier si plus de mandats"
                          field="a_relancer"
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          label="Mettre à l'agenda"
                          field="agenda"
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6" v-if="creditor.agenda.value">
                        <b-button @click="suppressFromAgenda()" size="sm"
                          >Supprimer de l'agenda</b-button
                        >
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="nom"
                          :readonly="!edit"
                          :table="creditor"
                          :required="true"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                        <mh-input
                          field="prenom"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="BOBID"
                          label="Clé comptable"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                        <mh-input
                          field="titre"
                          :autocomplete="{ field: 'creancier.titre' }"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="4"
                          contentColsLg="8"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <mh-input
                      field="address1"
                      :readonly="!edit"
                      :table="creditor"
                      debounce="400"
                      :autocomplete="{ field: 'google.places' }"
                      @enter="suggestAddress($event)"
                      labelColsLg="2"
                      contentColsLg="10"
                      @change="presave()"
                    ></mh-input>
                    <mh-input
                      field="address2"
                      :readonly="!edit"
                      :table="creditor"
                      labelColsLg="2"
                      contentColsLg="10"
                      @change="presave()"
                    ></mh-input>
                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="localite"
                          :autocomplete="{ field: 'creancier.localite' }"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="4"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="codepostal"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="pays"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="langue"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="telephone"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="telephone_prive"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <mh-input
                          field="gsm"
                          :readonly="!edit"
                          :table="creditor"
                          isMobileNumber
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col sm="6">
                        <mh-input
                          field="fax"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="envoiEmail"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="envoi_accuses"
                          label="Envoyer les accusés"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          class="blue"
                          field="email"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          class="blue"
                          field="email_compta"
                          label="Email comptabilité"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <mh-input
                      field="url"
                      :readonly="!edit"
                      :table="creditor"
                      labelColsLg="2"
                      @change="presave()"
                    ></mh-input>

                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="tva_pays"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                        <b-row>
                          <b-col lg="12">
                            <mh-input
                              field="useTVA"
                              :readonly="!edit"
                              :table="creditor"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                          <b-col lg="12">
                            <mh-input
                              field="assignation"
                              :readonly="!edit"
                              :table="creditor"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                          <b-col lg="12">
                            <mh-input
                              label="En faillite"
                              field="faillite"
                              :readonly="!edit"
                              :table="creditor"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                        </b-row>
                        <mh-input
                          field="qualiteFR"
                          :readonly="!edit"
                          :table="creditor"
                          debounce="500"
                          @change="goTranslate"
                        ></mh-input>
                        <div
                          class="mt-2"
                          v-if="proposition !== creditor.qualiteFR.value"
                        >
                          <a
                            href="#"
                            @click.prevent="
                              creditor.qualiteFR.value = proposition
                            "
                            ><b-badge>{{ proposition }}</b-badge></a
                          >
                        </div>
                        <template v-if="edit">
                          <mh-input
                            field="qualiteNL"
                            :readonly="!edit"
                            :table="creditor"
                            @change="presave()"
                          ></mh-input>
                          <mh-input
                            field="qualiteEN"
                            :readonly="!edit"
                            :table="creditor"
                            @change="presave()"
                          ></mh-input>
                          <mh-input
                            field="qualiteALL"
                            :readonly="!edit"
                            :table="creditor"
                            @change="presave()"
                          ></mh-input>
                        </template>
                        <b-row>
                          <b-col lg="12">
                            <mh-input
                              field="defaultCommission"
                              :readonly="!edit"
                              :table="creditor"
                              append="%"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                          <b-col lg="12">
                            <mh-input
                              field="clause_penale"
                              :readonly="!edit"
                              :table="creditor"
                              append="%"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                          <b-col lg="12">
                            <mh-input
                              field="taux_interet"
                              :readonly="!edit"
                              :table="creditor"
                              append="%"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                        </b-row>
                        <mh-input
                          field="avocatID"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="tva"
                          :readonly="!edit"
                          :table="creditor"
                          @change="checkDuplicateTva(creditor.tva.value)"
                        ></mh-input>
                        <mh-input
                          field="registre"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                        <mh-input
                          field="conformToFR"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                        <template v-if="edit">
                          <mh-input
                            field="conformToNL"
                            :readonly="!edit"
                            :table="creditor"
                            @change="presave()"
                          ></mh-input>
                          <mh-input
                            field="conformToEN"
                            :readonly="!edit"
                            :table="creditor"
                            @change="presave()"
                          ></mh-input>
                          <mh-input
                            field="conformToALL"
                            :readonly="!edit"
                            :table="creditor"
                            @change="presave()"
                          ></mh-input>
                        </template>
                        <b-row>
                          <b-col lg="12">
                            <mh-input
                              field="indemnite_min"
                              :readonly="!edit"
                              :table="creditor"
                              append="€"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                          <b-col lg="12">
                            <mh-input
                              field="fraisDeplacement"
                              :readonly="!edit"
                              :table="creditor"
                              append="€"
                              @change="presave()"
                            ></mh-input>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <mh-input
                      field="comment"
                      :readonly="!edit"
                      :table="creditor"
                      labelColsLg="2"
                      @change="presave()"
                    ></mh-input>
                  </b-card>
                </b-col>
                <b-col sm="12" lg="6">
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                  >
                    <ul style="list-style-type: none; padding-left: 0">
                      <li>
                        <a
                          :href="
                            'https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=fr&nummer=' +
                              creditor.tva.value +
                              '&actionLu=Recherche'
                          "
                          target="_blank"
                          >Rechercher via la Banque Carrefour</a
                        >
                      </li>
                      <li>
                        <a
                          :href="
                            'http://www.ejustice.just.fgov.be/cgi_tsv/tsv_rech.pl?language=fr&btw=' +
                              creditor.tva.value +
                              '&liste=Liste'
                          "
                          target="_blank"
                          >Rechercher les publications</a
                        >
                      </li>
                      <li>
                        <a
                          :href="
                            'http://www.ejustice.just.fgov.be/cgi/rech.pl?language=fr&text1=' +
                              creditor.tva.value +
                              '&liste=Liste'
                          "
                          target="_blank"
                          >Rechercher Personnes Physiques</a
                        >
                      </li>
                    </ul>
                  </b-card>
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                  >
                    <b-row>
                      <b-col lg="6">
                        <mh-input
                          field="soldeActivityReport"
                          :readonly="!edit"
                          :table="creditor"
                          append="€"
                          @change="presave()"
                        ></mh-input>
                        <mh-input
                          field="numCompte"
                          :readonly="!edit"
                          :table="creditor"
                          type="IBAN"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="6">
                        <mh-input
                          field="acceptRegularisation"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="6"
                          @change="presave()"
                        ></mh-input>
                        <mh-input
                          field="payByVirement"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="6"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col lg="12">
                        <mh-input
                          field="note_releve"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="2"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card
                    class="mb-2 bg-light shadow"
                    header-text-variant="light"
                  >
                    <b-row>
                      <b-col lg="12">
                        <mh-input
                          field="hasClientAccess"
                          :readonly="!edit"
                          :table="creditor"
                          labelColsLg="2"
                          @change="presave()"
                        ></mh-input>
                      </b-col>

                      <b-col
                        lg="6"
                        sm="12"
                        v-if="creditor.hasClientAccess.value == 'yes'"
                      >
                        <mh-input
                          field="login"
                          :readonly="!edit || creditor.keycloak_sub != ''"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                      <b-col
                        lg="6"
                        sm="12"
                        v-if="creditor.hasClientAccess.value == 'yes'"
                      >
                        <mh-input
                          field="password"
                          :readonly="!edit"
                          :table="creditor"
                          @change="presave()"
                        ></mh-input>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="id !== 0 && creditor.hasClientAccess.value == 'yes'"
                    >
                      <b-col lg="12">
                        <b-button
                          target="_blank"
                          size="sm"
                          @click="portail()"
                          variant="info"
                          class="my-2 text-right"
                          >Accéder au portail du client</b-button
                        >
                        <b-button
                          @click="send_login()"
                          size="sm"
                          class="my-2 ml-2"
                          variant="info"
                          >Envoyer les codes par email
                        </b-button>
                        <b-button
                          title="Générer un login et un mot de passe"
                          size="sm"
                          class="my-2 ml-2"
                          variant="success"
                          @click="magicLogin()"
                          icon
                          ><i class="fad fa-wand-magic"></i
                        ></b-button>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-card
                    class="mb-2 shadow"
                    header-text-variant="light"
                    header-tag="h6"
                  >
                    <b-table
                      v-if="creditor.notes.length > 0"
                      id="notesTable"
                      small
                      striped
                      hover
                      :fields="notesFields"
                      :items="creditor.notes"
                    >
                      <template v-slot:cell(date)="data">{{
                        toDate(data.item.date)
                      }}</template>
                      <template v-slot:cell(nom)="data"
                        >{{ data.item.prenom }} {{ data.item.nom }}</template
                      >
                      <template v-slot:cell(content)="data">
                        <div v-html="nl2br(data.item.content)"></div>
                      </template>
                      <template v-slot:cell(actions)="data">
                        <b-dropdown
                          size="sm"
                          text="..."
                          dropleft
                          block
                          no-caret
                          variant="outline-secondary"
                        >
                          <b-dropdown-item @click="openEditNote(data.item)"
                            >Éditer</b-dropdown-item
                          >
                          <b-dropdown-item
                            v-if="$store.getters.isSuperAdmin"
                            @click="deleteNote(data.item.ID)"
                            >Supprimer</b-dropdown-item
                          >
                        </b-dropdown>
                      </template>
                    </b-table>
                    <div v-else-if="creditor.ID.value">
                      <b-alert show>Pas de notes</b-alert>
                    </div>
                    <b-button
                      v-if="creditor.ID.value"
                      size="sm"
                      v-b-modal.modal-addNote
                      variant="success"
                      >Ajouter une note</b-button
                    >
                    <b-modal
                      @ok="addNote"
                      id="modal-addNote"
                      title="Ajouter une note"
                      cancel-title="Annuler"
                    >
                      <b-form-textarea
                        id="textarea"
                        v-model="note"
                        placeholder="Entrez votre note ici"
                        rows="10"
                        max-rows="10"
                      ></b-form-textarea>
                    </b-modal>
                    <b-modal
                      @ok="editNote"
                      ref="modal-editNote"
                      title="Éditer une note"
                      cancel-title="Annuler"
                    >
                      <b-form-textarea
                        id="textarea"
                        v-model="editedNote"
                        placeholder="Entrez votre note ici"
                        rows="10"
                        max-rows="10"
                      ></b-form-textarea>
                    </b-modal>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <template v-if="creditor.ID.value">
              <b-tab
                lazy
                v-if="creditor.tva.value !== '' && bceLoaded"
                title="BCE"
              >
                <b-row>
                  <b-col lg="4" sm="12">
                    <!-- <b-card
                      class="mb-2"
                      header-text-variant="light"
                      header-tag="h6"
                      header="Données de l'entité enregistrée"
                      bg-variant="secondary"
                    > -->
                    <b-list-group>
                      <b-list-group-item
                        variant="primary"
                        v-for="(info, index) in bce.entity"
                        :key="index"
                      >
                        <b-row>
                          <b-col lg="3">{{ index }}</b-col>
                          <b-col lg="9">
                            <div v-for="(line, i) in info" :key="i">
                              {{ line }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                    <!-- </b-card> -->
                  </b-col>
                  <b-col v-if="bceLoaded" lg="4" sm="12">
                    <!-- <b-card
                      class="mb-2"
                      header-text-variant="light"
                      header-tag="h6"
                      header="Données de l'unité d'établissement"
                      bg-variant="secondary"
                    > -->
                    <b-list-group>
                      <b-list-group-item
                        variant="primary"
                        v-for="(info, index) in bce.unity"
                        :key="index"
                      >
                        <b-row>
                          <b-col lg="3">{{ index }}</b-col>
                          <b-col lg="9">
                            <div v-for="(line, i) in info" :key="i">
                              {{ line }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                    <!-- </b-card> -->
                  </b-col>
                  <b-col
                    v-if="publicationsLoaded"
                    lg="4"
                    sm="12"
                    class="border"
                  >
                    <!-- <b-card
                      class="mb-2"
                      header-text-variant="light"
                      header-tag="h6"
                      header="Publications au moniteur"
                      bg-variant="secondary"
                    > -->
                    <b-table
                      striped
                      hover
                      small
                      :fields="pubfields"
                      :items="publications"
                    >
                      <template v-slot:cell(infos)="data">
                        <div
                          v-for="(info, index) in data.item.infos"
                          :key="index"
                        >
                          {{ info }}
                        </div>
                      </template>
                      <template v-slot:cell(document)="data">
                        <span v-if="data.item.document">
                          <b-button
                            size="sm"
                            class="btn-xs"
                            variant="info"
                            target="_blank"
                            :href="data.item.document"
                          >
                            <b-icon icon="file-earmark-arrow-down"></b-icon>
                          </b-button>
                        </span>
                      </template>
                    </b-table>
                    <!-- </b-card> -->
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab
                lazy
                v-if="creditor.tva.value !== ''"
                title="Centrale des bilans"
              >
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-card
                      class="mb-2 bg-light shadow"
                      header-text-variant="light"
                      header-tag="h6"
                    >
                      <h6>
                        Banque Nationale de Belgique / Centrale des bilans
                      </h6>
                      <template v-if="creditor.nbb.length">
                        <b-table
                          striped
                          hover
                          responsive
                          :fields="nbb_fields"
                          :items="creditor.nbb"
                        >
                          <template v-slot:cell(actions)="data">
                            <b-button
                              title="PDF du bilan"
                              icon
                              size="sm"
                              class="btn-sm ml-2"
                              variant="secondary"
                              target="_blank"
                              :href="getNbbUrl(data.item.ID)"
                            >
                              <b-icon-printer-fill></b-icon-printer-fill>
                            </b-button>
                          </template>
                        </b-table>
                      </template>
                      <template v-else>
                        <b-alert show>
                          Vous n'avez pas encore de données synchronisées ce
                          créancier avec la BNB
                        </b-alert>
                      </template>
                      <b-button @click="synchronizeNbb()" variant="secondary"
                        >Synchroniser</b-button
                      >
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab lazy title="Documents">
                <Documents
                  object="creancier"
                  :id="creditor.ID.value"
                ></Documents>
              </b-tab>
              <b-tab lazy title="Factures">
                <creditor-invoices
                  v-if="loaded"
                  :id="creditor.ID.value"
                ></creditor-invoices>
              </b-tab>

              <b-tab lazy :active="options.tab == 'mandats'" title="Mandats">
                <div class="d-flex justify-content-start">
                  <b-button
                    v-if="edit"
                    :disabled="newWarrant"
                    @click="newWarrant = true"
                    variant="secondary"
                    size="sm"
                    class="mb-3 mr-2"
                    >Nouveau carnet</b-button
                  >
                  <b-button
                    v-if="edit"
                    :disabled="newWarrant"
                    @click="expireAll()"
                    variant="danger"
                    size="sm"
                    class="mb-3 mr-2"
                    >Expirer tous les carnets</b-button
                  >
                  <b-form-checkbox
                    v-model="activeWarrants"
                    name="check-button"
                    switch
                    class="mb-3"
                  >
                    {{ activeWarrants ? "Mandats actifs" : "Tous les mandats" }}
                  </b-form-checkbox>
                </div>

                <creditor-new-warrant
                  @cancel="newWarrant = false"
                  v-if="newWarrant"
                  :id="creditor.ID.value"
                >
                </creditor-new-warrant>

                <creditor-warrants
                  v-if="loaded && !newWarrant"
                  ref="creditor_warrants"
                  :id="creditor.ID.value"
                  :active="activeWarrants"
                ></creditor-warrants>
              </b-tab>
              <b-tab lazy title="Relevés">
                <creditor-account-statements
                  v-if="loaded"
                  :id="creditor.ID.value"
                >
                </creditor-account-statements>
              </b-tab>
              <b-tab
                lazy
                :active="options.tab == 'activite'"
                title="Paiements en attente"
              >
                <creditor-activity v-if="loaded" :id="creditor.ID.value">
                </creditor-activity>
              </b-tab>
              <b-tab
                lazy
                :active="options.tab == 'statistique'"
                title="Statistiques"
              >
                <creditor-stats
                  v-if="loaded"
                  :id="creditor.ID.value"
                ></creditor-stats>
              </b-tab>
            </template>
            <template #tabs-end>
              <li v-if="edit" class="nav--item ml-auto mt--1">
                <b-button
                  @click="save()"
                  size="sm"
                  :disabled="dataChanged ? false : true"
                  variant="success"
                  >Enregistrer les modifications</b-button
                >
              </li>
            </template>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import creditors from "@/services/creditors.js";
import bce from "@/services/bce.js";
import DateTime from "@/services/DateTime.js";

import MhInput from "@/components/MhInput.vue";
import CreditorInvoices from "@/components/CreditorInvoices";
import CreditorWarrants from "@/components/CreditorWarrants";
import Documents from "@/components/Documents";
import CreditorAccountStatements from "@/components/CreditorAccountStatements";
import CreditorNewWarrant from "@/components/CreditorNewWarrant";
import CreditorActivity from "@/components/CreditorActivity";
import CreditorStats from "@/components/CreditorStats";
export default {
  name: "creditor-view",
  components: {
    MhInput,
    CreditorInvoices,
    CreditorWarrants,
    CreditorAccountStatements,
    CreditorNewWarrant,
    CreditorActivity,
    CreditorStats,
    Documents,
  },
  props: {
    _new: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {
        return {
          tab: "",
        };
      },
    },
  },

  data() {
    return {
      activeWarrants: false,
      proposition: "",
      note: "",
      edit: true,
      editedNote: "",
      editedNoteId: null,
      originalHash: null,
      dataChanged: false,
      renderBreadCrumb: 0,
      pdfPath: null,
      newWarrant: false,
      creditor: {},
      bce: {},
      busy: false,
      publications: {},
      nbb_fields: [
        {
          key: "deposit_date",
          label: "Date de dépôt",
          sortable: true,
          formatter: (el) => this.toDate(el),
        },
        {
          key: "type",
          label: "Type",
        },
        {
          key: "model_name",
          label: "Nom du modèle",
        },
        {
          key: "reference",
          label: "Référence",
        },
        {
          key: "period_end_date",
          label: "Date de fin d'exercice",
          sortable: true,
          formatter: (el) => this.toDate(el),
        },
        {
          key: "language",
          label: "Langue",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      documentsFields: [
        {
          key: "date_encodage",
          label: "Date",
          sortable: true,
        },
        {
          key: "intitule",
          label: "Nom",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
      ],
      notesFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "nom",
          label: "Éditeur de la note",
          sortable: true,
        },
        {
          key: "content",
          label: "Contenu",
          sortable: false,
        },
      ],
      pubfields: [
        {
          key: "id",
        },
        {
          key: "timestamp",
          label: "Date",
          sortable: true,
        },
        {
          key: "infos",
          label: "Publications",
          sortable: true,
        },
        {
          key: "document",
          label: "Document",
          sortable: false,
        },
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Créanciers",
          to: { name: "creditors" },
        },
      ],
      loaded: false,
      bceLoaded: false,
      publicationsLoaded: false,
      id: 0,
      renderFields: 0,
    };
  },

  created() {
    if (this._new) {
      this.id = 0;
    } else {
      this.id = this.$route.params.id;
    }
    if (this.edit) {
      this.notesFields.push({
        key: "actions",
        label: "Actions",
        thStyle: "width:100px",
        sortable: false,
      });
    }
    this.load(true);
  },
  async beforeRouteLeave(to, from, next) {
    if (this.dataChanged) {
      await this.$root.$bvModal
        .msgBoxConfirm(
          "Des modifications ont été apportés à ce créancier. Enregistrer?",
          {
            cancelTitle: "Non",
            okTitle: "Oui",
          }
        )
        .then((value) => {
          if (value) {
            this.save();
          }
          next(false);
        })
        .catch(() => next());
    } else {
      next();
    }
  },
  methods: {
    expireAll() {
      this.$bvModal.msgBoxConfirm("Êtes-vous sûr de vouloir expirer ces mandats? Cette opération n'entraîne pas de facturation, ni de note de crédit !!").then((ok) => {
        if (!ok) return;
        creditors.warrants_expire(this.creditor.ID.value).then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Opération réussie", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.$refs.creditor_warrants.load();
          }
        });
      });
    },
    suppressFromAgenda() {
      this.creditor.agenda.value = "";
      this.presave();
    },
    getNbbUrl(id) {
      return this.$store.getters.url + "/nbb/" + id + "/pdf";
    },
    synchronizeNbb() {
      this.busy = true;
      bce.synchronizeNbb(this.creditor.tva.value).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Débiteur syncrhonisé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load();
          this.busy = false;
        } else {
          this.busy = false;
          this.$bvToast.toast("Pas de résultats", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "info",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    portail() {
      this.save(true);
    },
    presave() {
      this.dataChanged = true;
    },
    magicLogin() {
      if (this.creditor.ID.value) {
        if (this.creditor.nom.value.trim() != "") {
          this.creditor.login.value =
            this.creditor.nom.value.toLowerCase() +
            "-" +
            this.creditor.ID.value;
        } else if (this.creditor.prenom.value.trim() != "") {
          this.creditor.login.value =
            this.creditor.prenom.value.toLowerCase() +
            "-" +
            this.creditor.ID.value;
        } else if (this.creditor.nom_soc.value.trim() != "") {
          this.creditor.login.value =
            this.creditor.nom_soc.value.toLowerCase().replace(/\W+/g, "") +
            "-" +
            this.creditor.ID.value;
        }
      }
      this.creditor.password.value = this.generatePassword();
    },
    generatePassword() {
      let nums = "0123456789";
      let chars = [
        "pa",
        "po",
        "li",
        "ri",
        "lac",
        "mou",
        "sol",
        "di",
        "van",
        "car",
        "ton",
        "tin",
        "lu",
        "ca",
        "teur",
        "bet",
        "pha",
        "cro",
        "ge",
        "tram",
        "ra",
      ];
      let pw = "";
      for (let i = 0; i < 3; i++) {
        pw += chars[Math.floor(Math.random() * chars.length)];
      }
      for (let i = 0; i < 2; i++) {
        pw += nums.charAt(Math.floor(Math.random() * nums.length));
      }
      return pw;
    },
    send_login() {
      creditors.sendLogin(this.creditor.ID.value).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Email envoyé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load();
        } else if (response.data.error) {
          this.$bvToast.toast("L'email n'a pas pu être envoyé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    checkDuplicateTva(tva) {
      creditors
        .checkDuplicateTva(this.creditor.ID.value, tva)
        .then((response) => {
          if (response.data.status == "error") {
            this.creditor.tva.error = response.data.message;
          } else {
            this.creditor.tva.error = false;
          }
        });
    },
    suggestAddress(payload) {
      this.creditor.address1.value = payload.route || "";
      if (payload.street_number) {
        this.creditor.address1.value += ", " + payload.street_number;
      }
      this.creditor.address2.value = "";
      this.creditor.localite.value = payload.city || "";
      this.creditor.pays.value = payload.country || "";
      this.creditor.codepostal.value = payload.postal_code || "";
      this.presave();
    },
    goTranslate() {
      creditors
        .translateQuality(this.creditor.qualiteFR.value)
        .then((response) => {
          if (response.data.length > 0) {
            this.proposition = response.data[0].fr;
            this.creditor.qualiteNL.value = response.data[0].nl;
            this.creditor.qualiteEN.value = response.data[0].en;
            this.creditor.qualiteALL.value = response.data[0].all;
            this.presave();
          }
        });
    },
    load(addBread = false) {
      creditors.get(this.id).then((response) => {
        this.creditor = response.data;
        this.originalHash = JSON.stringify(this.creditor);
        if (addBread) {
          this.items.push({ text: this.creditor.nom_soc.value, active: true });
        }
        this.loaded = true;
        this.checkDuplicateTva(this.creditor.tva.value);
        this.$store.dispatch("history", {
          object: "creancier",
          objectID: this.creditor.ID.value,
          message: "Consultation du créancier",
          data: {},
        });
        bce.get(this.creditor.tva.value).then((response) => {
          this.bce = response.data;
          this.bceLoaded = true;
        });
        bce.getPublications(this.creditor.tva.value).then((response) => {
          this.publications = response.data;
          this.publicationsLoaded = true;
        });
      });
    },
    openEditNote(item) {
      this.editedNote = item.content;
      this.editedNoteId = item.ID;
      this.$refs["modal-editNote"].show();
    },
    deleteNote(id) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer cette note", {
          cancelTitle: "Annuler",
          okTitle: "Supprimer",
        })
        .then(() => {
          creditors
            .deleteNote({
              noteID: id,
              creditorID: this.creditor.ID.value,
            })
            .then((response) => {
              if (response.data.success) {
                this.$bvToast.toast("Note supprimée", {
                  title: `Recuperator`,
                  toaster: "b-toaster-top-right",
                  variant: "success",
                  autoHideDelay: 2000,
                  solid: false,
                });
                this.load();
              } else if (response.data.error) {
                this.$bvToast.toast("Erreur : " + response.data.error, {
                  title: `Recuperator`,
                  toaster: "b-toaster-top-right",
                  variant: "danger",
                  autoHideDelay: 2000,
                  solid: false,
                });
              }
            });
        });
    },
    editNote() {
      creditors
        .editNote({
          noteID: this.editedNoteId,
          creditorID: this.creditor.ID.value,
          negotiateurID: this.$store.getters.negoID,
          note: this.editedNote,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Note modifée", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.load();
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
    addNote() {
      creditors
        .addNote({
          creditorID: this.creditor.ID.value,
          negotiateurID: this.$store.getters.negoID,
          note: this.note,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Note enregistrée", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.load();
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
    save(logout = false) {
      /* for (let el in this.creditor) {
        if(this.creditor[el].error) {
          this.$bvToast.toast("Veuillez corriger les erreurs d'encodage", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 10000,
            solid: false,
          });
          return;
        }
      } */
      this.busy = true;
      this.dataChanged = false;
      creditors.post(this.creditor).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Créancier enregistré", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });

          if (logout) {
            this.$store.dispatch("logout");
          }
          if (this.$props._new) {
            this.id = response.data.id;
            this.$router.push({
              name: "creditorView",
              params: { id: response.data.id },
            });
          }
          for (let el in this.creditor) {
            this.creditor[el].error = false;
          }
          this.creditor.keycloak_sub.value = response.data.kc;
          this.load();
          this.items[2] = { text: this.creditor.nom_soc.value, active: true };
          this.renderBreadCrumb++;
          this.renderFields++;
        } else if (response.data.fail) {
          for (let el in this.creditor) {
            this.creditor[el].error = false;
          }
          response.data.fail.forEach((element) => {
            this.creditor[element.field].error = element.errors.join(" ; ");
          });
          this.$bvToast.toast("Champs invalides", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
        this.busy = false;
      });
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
  },
};
</script>
